import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import Header from '../components/Header';
import Footer from '../components/Footer';

const Dashboard = () => {
  const { user, loading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading && user) {
      console.log('User data:', user);
      console.log('User type:', user.user_type);
      console.log('Is company:', user.is_company);
      
      if (user.is_company || user.user_type === 'company') {
        console.log('Redirecting to company dashboard');
        navigate('/company-dashboard', { replace: true });
      } else if (user.is_candidate || user.user_type === 'candidate') {
        console.log('Redirecting to candidate dashboard');
        navigate('/candidate-dashboard', { replace: true });
      }
    }
  }, [user, loading, navigate]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600"></div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      <div className="py-12 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-12">
            <h1 className="text-4xl font-bold text-gray-900 mb-4">Candidate Dashboard</h1>
            <p className="text-xl text-gray-600">Manage your job applications and resume</p>
          </div>
          <div className="bg-white p-8 rounded-lg shadow">
            <p className="text-center text-gray-500">Candidate dashboard content will be implemented here</p>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Dashboard;
